import { PHMS_CASE_CONTEXT_TERMINOLOGY } from "../../phms-case-context.terminology";
import { PHMS_FACILITY_TERMINOLOGY } from "../../phms-facility.terminology";
import { TERMINOLOGY_TOKENS } from "@app/shared/terminology/terminology-token.catalog";
import { defineTerminologyUsage, TerminologyUsageDeclaration, TERMINOLOGY_CONFIGURATION_CODES, TERMINOLOGY_USAGE_KINDS } from "@app/shared/terminology/terminology-usage";

const surface = { featureCode: "phms", surfaceCode: "hearing-assessment", componentCode: "HearingTopicSectionComponent",
  locations: [{ kind: "route" as const, value: "/phms/hearing-detail" }] };
const reuse = (name: string, source: TerminologyUsageDeclaration) => defineTerminologyUsage({
  ...source, usageId: `phms.at-hearing.assessment.${name}`, surface,
});
export const HEARING_ASSESSMENT_TERMINOLOGY = {
  violations: reuse("violations", PHMS_CASE_CONTEXT_TERMINOLOGY.violations.heading),
  behaviorSummary: reuse("behavior-summary", PHMS_FACILITY_TERMINOLOGY.suitability.behaviorSummary),
  status: defineTerminologyUsage({ usageId: "phms.at-hearing.assessment.status", token: TERMINOLOGY_TOKENS.operationalStatus,
    fallbackText: "Status", kind: TERMINOLOGY_USAGE_KINDS.gridHeader, configurationCode: TERMINOLOGY_CONFIGURATION_CODES.programPack, surface }),
} as const;
